const configs =  {
    createFishSchoolInterval: 1,
    fishEachSchoolRange: [2, 100],
    fishSchoolRadius: 200,
    jellyfishStep: 10,
    jellyFishFramesCount: 9,
    collisionDistance: 250,
    plantsCountRange: [5, 8],
    extraX: 2.5,
    extraY: 5,
    backgroundColor: "#E0FFFF",
    infoImage: "/oceanFlow/eventKeys.png",
    infoImage2: "/oceanFlow/mouse.png",
    info: "This game represents a jellyfish, which travels across the ocean, while the fish are afraid of it and the jellyfish's appearance scares them away.You can move the jellyfish using keyboard keys indicated above.Scare as more fish as you can!"
}
export default configs;